import {
  Button as RadixToolbarButton,
  Root,
  ToggleGroup,
  ToggleItem,
} from '@radix-ui/react-toolbar';
import clsx from 'clsx';
import { ComponentPropsWithRef } from 'react';
import { IconButton } from '../button/icon-button';
import { toolbar, toolbarToggleGroup } from './toolbar.css';

export const Toolbar = ({
  className,
  ...props
}: ComponentPropsWithRef<typeof Root>) => (
  <Root className={clsx(toolbar, className)} {...props} />
);

export const ToolbarToggleGroup = ({
  className,
  ...props
}: ComponentPropsWithRef<typeof ToggleGroup>) => (
  <ToggleGroup className={clsx(toolbarToggleGroup, className)} {...props} />
);

export const ToolbarToggleItem = ({
  className,
  children,
  ...props
}: ComponentPropsWithRef<typeof ToggleItem>) => (
  <ToggleItem className={clsx()} {...props} asChild>
    <IconButton variant="ghost" size="small" rounded={false}>
      {children}
    </IconButton>
  </ToggleItem>
);

export const ToolbarButton = (
  props: ComponentPropsWithRef<typeof RadixToolbarButton>,
) => <RadixToolbarButton {...props} />;
